export const REVIEW_SECTION_IDS = {
  BANKING_EXPERIENCE_AND_OVERDRAFT_FEES: 'banking-experience-and-overdraft-fees-section',
  OVERVIEW: 'overview-section',
  PRODUCT_REVIEWS: 'product-review-section',
  FAQ: 'faq-section',
  RATING_METHODOLOGY: 'rating-methodology-section',
} as const;

export const REVIEW_SECTION_HEADERS = {
  BANKING_EXPERIENCE_AND_OVERDRAFT_FEES: 'Customer experience & overdraft fees',
  OVERVIEW: 'Overview',
  PRODUCT_REVIEWS: 'Product reviews',
  FAQ: "FAQ's",
  RATING_METHODOLOGY: 'Rating methodology',
} as const;
